export default {
    pageSize: 100
};
